import { render, staticRenderFns } from "./ProjectRight.vue?vue&type=template&id=c4592bd0&scoped=true&"
import script from "./ProjectRight.vue?vue&type=script&lang=js&"
export * from "./ProjectRight.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRight.vue?vue&type=style&index=0&id=c4592bd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4592bd0",
  null
  
)

export default component.exports